/* eslint-disable react/jsx-pascal-case */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import InputFields from "../../../InputFields";
import parse from "html-react-parser";

class SubscriptionAgreement extends Component {
  render() {
    const { investForm } = this.props;
    return (
      <>
        <Row className="inputRow">
          <Col lg={12} className="inputCol">
            <div className="subscriptionDiv">
              {parse(
                '<style>\n  @font-face {\n    font-family: \'Sacramento\';\n    font-style: normal;\n    font-weight: 400;\n    src: local(\'Sacramento\'), local(\'Sacramento-Regular\'), url(\'https://s3.amazonaws.com/fundamerica/files/fonts/Sacramento.ttf\') format(\'truetype\');\n  }\n\n  .fa__signature { margin-top: 2em;}\n  .fa__signature h1 { font-size: 1.25em; font-weight: bold; }\n  .fa__signature h1:after { content: ":"; }\n  .fa__signature h2 { font-size: 1em; font-weight: bold; }\n  .fa__signature .fa__signature_data { border: 0; }\n  .fa__signature .fa__signature_data th { border: 0; font-weight: bold; text-align: left; }\n  .fa__signature .fa__signature_data th:after { content: ":"; }\n  .fa__signature .fa__signature_data td { border: 0; font-weight: normal; text-align: left; vertical-align: bottom;}\n  .fa__signature .fa__signed { font-family: \'Sacramento\', cursive, fantasy; font-size: 2em; margin-top: 1em; text-decoration: underline; }\n  .fa__signature .fa__blank_signature_data th, .fa__signature .fa__blank_signature_data td { padding-bottom: 1.5em }\n  .fa__signature .fa__blank_signature_data td { padding-left: 1em }\n</style>\n\n<p>I, ,agree to this random investment. Please sign here</p>\n\n<p></p>\n<div id="fa__issuer_signature" class="fa__signature">\n  <h1>Issuer</h1>\n  <br>\n  <table class="fa__signature_data fa__blank_signature_data">\n    <tr>\n      <th>By</th>\n      <td>______________________________</td>\n    </tr>\n    <tr>\n      <th>Name</th>\n      <td>______________________________</td>\n    </tr>\n    <tr>\n      <th>Title</th>\n      <td>______________________________</td>\n    </tr>\n  </table>\n</div>\n\n\n<p></p>\n<div id="fa__subscriber_signature" class="fa__signature">\n  <h1>Subscriber</h1>\n  <br>\n  <table class="fa__signature_data fa__blank_signature_data">\n    <tr>\n      <th>By</th>\n      <td>______________________________</td>\n    </tr>\n    <tr>\n      <th>Name</th>\n      <td>______________________________</td>\n    </tr>\n    <tr>\n      <th>Title</th>\n      <td>______________________________</td>\n    </tr>\n  </table>\n</div>\n\n\n<p>Amount: $0.00</p>\n'
              )}
            </div>
          </Col>
          <Col lg={12} className="inputCol">
            <InputFields
              label={`Type signature to sign the agreement: ${investForm?.investment_info?.name}.`}
              placeholder={`Type signature to sign the agreement: ${investForm?.investment_info?.name}.`}
              type="number"
              inputType="text"
              model=".signature"
            />
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  options: state.options,
  user: state.user,
  userActions: state.userActions,
  allDeals: state.allDeals,
  deal: state.deal,
  investForm: state.investForm,
  investFormCurrentModel: state.investFormCurrentModel,
});

export default connect(mapStateToProps)(SubscriptionAgreement);
